<template>
  <CommonLayout footer="floristFooter">
    <FloristHeader @suggestion="suggestion"></FloristHeader>
    <MeetingLayout :type="this.consts.meetingType.florist">
      <b-overlay :show="overlayShow" rounded="sm">
        <div class="base-color mh-550 shadow">
          <div class="p-2">
            <img :src="hearingData('imagePath')" class="w-100">
            <div class="col-sm-12 text-center pt-4">
              <h2>{{hearingData('title')}}</h2>
            </div>
            <div class="col-sm-12 text-center pt-1">
              <h5>{{hearingData('subtitle')}}</h5>
            </div>
            <div class="col-sm-12 text-center pt-1 white-space-pre-wrap" v-html="getHearingBody()"></div>
            <div class="text-right mt-5 mb-3 mr-5">
              <!--<b-button variant="outline-secondary" class="w-25 sub-button-color" @click="backPage" id="back">戻る</b-button>-->
            </div>
          </div>
        </div>
      </b-overlay>
    </MeetingLayout>
    <CommonModal ref="commonModal" />
  </CommonLayout>
</template>
<script>
import CommonLayout from '@/layout/CommonLayout'
import MeetingLayout from '@/layout/MeetingLayout'
import FloristHeader from '@/components/FloristHeader.vue'
import CommonModal from '@/components/CommonModal'
import HearingModel from '@/models/HearingModel'
import SignalingModel from '@/models/SignalingModel'
import CommonLogModel from '@/models/CommonLogModel'
import mstore from '@/store/meeting-store'
import fstore from '@/store/florist-store'

export default {
  name: 'FloristMeetingHearing',
  components: { CommonLayout, MeetingLayout, FloristHeader, CommonModal },
  data () {
    return {
      overlayShow: false,
      isSendFirstSignalingData: false
    }
  },
  computed: {
    getIsTargetAtendeeActive () {
      // フローリストとの疎通確立フラグ取得
      return mstore.getters.isTargetAtendeeActive
    },
    getSignalingData () {
      return fstore.getters.signalingReceiveData
    }
  },
  watch: {
    getIsTargetAtendeeActive: function (newData, oldData) {
      if (!this.isSendFirstSignalingData && mstore.getters.isTargetAtendeeActive) {
        this.sendSignalingApiData()
        this.isSendFirstSignalingData = true
      }
    },
    getSignalingData: function (newData, oldData) {
      try {
        newData['user'] = 'florist'
        newData['timestampMs'] = Date.now()
        CommonLogModel.apiSetStore(this.$bvModal, newData, () => {
        })

        if (newData['event'] === 'again') {
          // 情報の再送要求が来たら画面の情報を再送する
          this.sendSignalingApiData()
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'errorMessage': err.message}, () => {
        })
      }
    }
  },
  methods: {
    hearingData (key) {
      const store = HearingModel.getStore()
      if (!store) {
        return null
      }
      return store.contents[key]
    },
    getHearingBody () {
      const store = HearingModel.getStore()
      if (!store) {
        return null
      }
      let body = store.contents['body']
      if (body) {
        // bodyの会社名を置換
        body = body.replace('{会社名}', store.contents['companyName'])
        // bodyの改行を置換
        body = body.replace(/\\n/g, '<br/>')
      }
      return body
    },
    setApiData: async function (isReload = false) {
      this.overlayShow = true
      await HearingModel.apiSetStore(this.$bvModal, () => {
        this.overlayShow = false
      })

      if ((!this.isSendFirstSignalingData && mstore.getters.isTargetAtendeeActive) || isReload) {
        this.sendSignalingApiData()
        this.isSendFirstSignalingData = true
      }
    },
    sendSignalingApiData () {
      const apiData = HearingModel.getStore()
      if (!apiData) {
        return null
      }
      const projectType = localStorage.getItem('suggestionData') !== null && JSON.parse(localStorage.getItem('suggestionData')).projectType ? JSON.parse(localStorage.getItem('suggestionData')).projectType[0] : ''
      const suggestioType = localStorage.getItem('suggestionData') !== null && JSON.parse(localStorage.getItem('suggestionData')).suggestionType ? JSON.parse(localStorage.getItem('suggestionData')).suggestionType[0] : ''
      let apiRes = {}
      apiRes = {
        'status': apiData.status,
        'message': apiData.message,
        'project_type': projectType,
        'suggestion_type': suggestioType
      }
      Object.assign(apiRes, apiData)
      SignalingModel.sendApiEvent('getContents', this, apiRes)
    },
    nextPage () {
      if (localStorage.getItem('suggestionData') === null) {
        return this.$refs.commonModal.msgBoxOk('提案条件を設定してください')
      }
      const currentProjectType = JSON.parse(localStorage.getItem('suggestionData')).projectType[0]
      let targetPath = null
      if (this.consts.projectType.main.indexOf(currentProjectType) !== -1) {
        targetPath = '/florist/meeting/style_image_proposal'
      } else if (this.consts.projectType.finish.indexOf(currentProjectType) !== -1) {
        targetPath = '/florist/meeting/estimate'
      } else {
        targetPath = '/florist/meeting/product_proposal'
      }
      SignalingModel.sendClickEvent('next', this, {'target_path': targetPath.replace('florist', 'customer')})
      this.$router.push(targetPath)
    },
    backPage () {
      const targetPath = '/florist/meeting/send_mail'
      SignalingModel.sendClickEvent('back', this, {'target_path': targetPath.replace('florist', 'customer')})
      this.$router.push(targetPath)
    },
    suggestion () {
      this.setApiData(true)
    }
  },
  mounted () {
    this.setApiData()
  },
  destroyed () {
    if (HearingModel.getStore()) {
      HearingModel.removeStore()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/FloristMeetingHearing.vue